import { render } from "./basicDemo.vue?vue&type=template&id=5c9ae02c"
import script from "./basicDemo.vue?vue&type=script&lang=js"
export * from "./basicDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__